import { Component, ErrorInfo, ReactNode } from "react";
import { navigate } from '@reach/router';
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: any
  errorInfo?: any
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
    return { hasError: true, error: error, errorInfo: errorInfo };
  }

  public handleContinueClick = () => {
    this.setState({ hasError: false });
    navigate(-1);

  }

  public render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state;
      let errorStackMsg = "", errorInfoMsg = "", errorToString = "";
      if (error) {
        errorToString = error.toString();
        errorStackMsg = error.stack;
        console.log(error);
      }

      if (errorInfo) {
        errorInfoMsg = JSON.stringify(errorInfo);
      }
      return (<div className="error-page">
        <h1> Please report this problem with support team. Once reported <button onClick={() => {
          this.handleContinueClick()
        }}> click here to continue </button></h1>

        <hr />
        {errorToString}
        <hr />
        {errorStackMsg}
        <hr />
        {errorInfoMsg}
      </div>);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
